// ============================================================
// VidyaTrack — App Layout
// ============================================================

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar  from "./TopBar";

const SIDEBAR_W = 260;

export default function AppLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile,   setIsMobile]   = useState(window.innerWidth <= 768);
  const location = useLocation();

  // Track mobile breakpoint
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);

  // Close sidebar on route change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Prevent body scroll when mobile sidebar is open
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.body.style.overflow = (mobileOpen && isMobile) ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [mobileOpen, isMobile]);

  return (
    <div style={{ display:"flex", minHeight:"100vh", background:"var(--clr-bg,#f4f7fd)" }}>
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen}/>

      {/* Main column — offset by sidebar width on desktop only */}
      <div style={{
        marginLeft: isMobile ? 0 : SIDEBAR_W,
        flex:       1,
        display:    "flex",
        flexDirection: "column",
        minWidth:   0,
        minHeight:  "100vh",
        transition: "margin-left .28s cubic-bezier(0.4,0,0.2,1)",
      }}>
        <TopBar onMenuToggle={() => setMobileOpen(o => !o)}/>
        <main style={{ flex:1, padding: isMobile ? "14px" : "22px", overflowX:"hidden" }}>
          {children}
        </main>
      </div>
    </div>
  );
}
